(() => {
  const normalizeDesktopDropdowns = root => {
    const scope = root?.querySelectorAll ? root : document;

    scope
      .querySelectorAll('.header__nav-item.megamenu--links-only')
      .forEach(item => {
        item.classList.remove('megamenu', 'megamenu--links-only');
        item.classList.add('dropdown');
      });
  };

  normalizeDesktopDropdowns(document);

  document.addEventListener('shopify:section:load', event => {
    normalizeDesktopDropdowns(event.target);
  });
})();
